'use strict';

module.exports = /* @ngInject */ function($scope, $timeout, $filter, sbeStorageService, sbeStorageArticleService) {
	
	/**
	 * init controller mit supplier index
	 * @param  {string} supplier_company_id
	 */
	$scope.init = function(supplier_company_id, sku) {

		$scope.supplier_company_id = supplier_company_id;
		$scope.sku = sku;
		$scope.create = {};
		
		$scope.initForm('');
      	
		// load locations
		$scope.getInventory();		
	};

	/**
	 * initForm variablen. ist  'mode' angegeben, wird showForm auf true gesetzt
	 * @param  {string} mode edit oder create
	 */
	$scope.initForm = function(mode) {
		$scope.formMode = mode;
		$scope.showForm = mode !== '';
	}

	/**
	 * bearbeiten eines Lager starten
	 * @param  {inventory} inventory das zu bearbeitende Lager
	 */
	$scope.editInventoryForm = function (inventory) {
		$scope.create = inventory;
		$scope.initForm('edit');
	}

	/**
	 * anzeigen des Formulars, um ein neues Lager zuzuweisen
	 */
	$scope.addInventoryForm = function() {
		$scope.getLocations();
		$scope.initForm('create');
	}

	/**
	 * Lager aus dem Scope am Artikel hinterlegen
	 */
	$scope.addInventory = function () {
		$scope.create.id = null;
		$scope.create.productArticleNumber = $scope.sku;

		$scope.promise = sbeStorageArticleService.inventory.create($scope.create)
			.$promise.then(
			//success
			function(data) {
				$scope.getInventory();				
			},
			//error
			sbeStorageArticleService.error
		);
	};

	/**
	 * hinterlegtes Lager aktualisieren
	 */
	$scope.updateInventory = function () {		
		$scope.promise = sbeStorageArticleService.inventory.update({inventory_id:$scope.create.id}, $scope.create)
			.$promise.then(
			//success
			function(data) {
				$scope.getInventory();		
			},
			//error
			sbeStorageArticleService.error
		);
	};

	/**
	 * Artikel aus Lager entfernen
	 * @param  {inventory} inventory Der Inventory Eintrag
	 */
	$scope.deleteInventory = function (inventory) {
		if(confirm(gettxt.form.deleteConfirm)) {
			$scope.promise = sbeStorageArticleService.inventory.delete({inventory_id:inventory.id})
				.$promise.then(
				//success
				function(data) {
					$scope.getInventory();
					
				},
				//error
				sbeStorageArticleService.error
			);
		}
	};

	/**
	 * alle am Artikel hinterlegten Lager ziehen
	 */
	$scope.getInventory = function () {
		$scope.initForm('');
		$scope.location = {};
		$scope.warehouse = {};
		$scope.storageplace = {};
		$scope.setStorageplaceId(null);
		$scope.promise = sbeStorageArticleService.inventory.query(
			{
				supplier_company_id: $scope.supplier_company_id,
				sku: $scope.sku,
			})
			.$promise.then(
			//success
			function(data) {
				$scope.inventory = data;
			},
			//error
			sbeStorageArticleService.error
		);
	};

	/**
	 * alle Verfügbaren Standorte ziehen
	 */
	$scope.getLocations = function () {
		$scope.setStorageplaceId(null);
		$scope.promise = sbeStorageService.location.query(
			{
				supplier_company_id: $scope.supplier_company_id
			})
			.$promise.then(
			//success
			function(data) {
				$scope.locations = data;				
			},
			//error
			sbeStorageService.error
		);
	};


	/**
	 * alle Verfügbaren Lager eines Standortes ziehen
	 * @param  {location} location optional eine Location angeben, sonst wird die Location vom Scope gezogen
	 */
	$scope.getWarehouses = function (location) {
		$scope.create.storagePlaceId = null;
		if(typeof location != 'undefined')
			$scope.location = location;

		$scope.promise = sbeStorageService.warehouse.query({location_id: $scope.location.id}).$promise.then(
			//success
			function(data) {
				$scope.warehouses = data;
			},
			//error
			sbeStorageService.error
		);
	};

	/**
	 * id für aktuelles Lager in Formular scope.create setzen
	 * @param {storageplace} item das Lager. Ist kein Lagerplatz angegeben, wird die id auf null gesetzt, damit bei create kein conflict entsteht
	 */
	$scope.setStorageplaceId = function (item) {
		$scope.create.storagePlaceId = item === null ? null : item.id;
	}

	/**
	 * alle storageplaces eines Lagerplatzes ziehen
	 * @param  {warehouse} warehouse optional
	 */
	$scope.getStorageplaces = function (warehouse) {

		if(typeof warehouse != 'undefined')
			$scope.warehouse = warehouse;

		$scope.setStorageplaceId(null);

		$scope.promise = sbeStorageService.storageplace.query({warehouse_id: $scope.warehouse.id}).$promise.then(
			//success
			function(data) {
				$scope.storageplaces = data;
			},
			//error
			sbeStorageService.error
		);
	};


	/**
	 * wenn scope.location sich ändert, Werte zurücksetzen und Lagerorte Laden
	 * @param  {location} newValue
	 * @param  {location} oldValue
	 */
	$scope.$watch('location', function (newValue, oldValue) {
		if(newValue !== oldValue) {
			$scope.storageplaces = [];
			$scope.getWarehouses(newValue);
		}
	});

	/**
	 * wenn scope.warehouse sich ändert, Lagerplätze laden
	 * @param  {location} newValue
	 * @param  {location} oldValue
	 */
	$scope.$watch('warehouse', function (newValue, oldValue) {
		if(newValue !== oldValue && newValue != '')
			$scope.getStorageplaces(newValue);
	});

};
